module.exports = __webpack_public_path__ + "annualreview2017/static/img/coordinating-smart-appliances-to-offer-flexible-services@2x.1a8ea12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prosumer-square/coordinating-smart-appliances-to-offer-flexible-services@2x.png
// module id = 355
// module chunks = 0